import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ContentRendererCardFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id'>
  & { attachments: Array<(
    { __typename: 'Attachment' }
    & Pick<Types.Attachment, 'id' | 'mimeType' | 'url'>
  )> }
);

export const ContentRendererCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentRendererCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseContentRendererCardFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      ContentRendererCardFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseContentRendererCardFragmentResult
  extends Omit<Apollo.UseFragmentResult<ContentRendererCardFragment>, 'data'> {
  data?: ContentRendererCardFragment;
}

export const useContentRendererCardFragment = ({
  from,
  returnPartialData,
  ...options
}: UseContentRendererCardFragmentOptions): UseContentRendererCardFragmentResult => {
  const result = Apollo.useFragment<ContentRendererCardFragment>({
    ...options,
    fragment: ContentRendererCardFragmentDoc,
    fragmentName: 'ContentRendererCard',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ContentRendererCardFragment };
};
